import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import type { Purchase } from 'my-purchases/types/purchaseList'

import { MyPurchasesGenericEvents } from './constants'

export const sendOnClickDiscover = () =>
	sendGenericEvent(MyPurchasesGenericEvents.GO_SHOPPING)

export const sendOnClickPreviousPurchases = () => {
	sendGenericEvent(MyPurchasesGenericEvents.MY_PURCHASES, {
		label_1: 'show_previous_purchases',
	})
}

export const sendOnLoadingError = () => {
	sendGenericEvent(MyPurchasesGenericEvents.LOADING_ERROR, { action: 'show' })
}

export const sendOnLoadingRetry = () => {
	sendGenericEvent(MyPurchasesGenericEvents.LOADING_ERROR, { action: 'click' })
}

export const sendOnDownloadLabel = () => {
	sendGenericEvent(MyPurchasesGenericEvents.DOWNLOAD_RETURN_LABEL)
}

export const sendOnDownloadForm = () => {
	sendGenericEvent(MyPurchasesGenericEvents.DOWNLOAD_RETURN_FORM)
}

export const sendOnClickOrderTracking = () => {
	sendGenericEvent(MyPurchasesGenericEvents.MY_PURCHASES, {
		label_1: 'click_order_tracking',
	})
}

export const sendOnClickReturnButton = () => {
	sendGenericEvent(MyPurchasesGenericEvents.RETURNS_CLICK)
}

export const sendOnClickFindStore = () => {
	sendGenericEvent(MyPurchasesGenericEvents.FIND_STORE)
}

export const sendOnSearchOrder = () => {
	sendGenericEvent(MyPurchasesGenericEvents.SEARCH_ORDER)
}

export const sendOnClickCreateAccount = () => {
	sendGenericEvent(MyPurchasesGenericEvents.CREATE_ACCOUNT)
}

export const sendOnClickPurchaseDetail = (
	purchase: Purchase,
	isActive: boolean
) => {
	purchase.orders.forEach((order) => {
		const activeValue = isActive ? 'active' : 'inactive'
		const { id, status, alert } = order
		const eventData = {
			purchase_id: purchase.purchaseId,
			purchase_type: `${order.type}-${activeValue}`,
			order_id: id,
			order_status: status,
			order_alerts: alert,
		}
		sendGenericEvent(MyPurchasesGenericEvents.PURCHASE_DETAIL, eventData)
	})
}

export const sendCancelOrder = (isMulti = false) => {
	const eventData = {
		purchase_type: isMulti
			? MyPurchasesGenericEvents.MULTI_ORDER
			: MyPurchasesGenericEvents.SIMPLE_ORDER,
	}

	sendGenericEvent(MyPurchasesGenericEvents.CANCEL_ORDER, eventData)
}
